import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next';
import { Box, Button } from '@mui/material';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { i18nContext } from '../i18n/i18nContext';
import { HeldTimesContext } from '../Root/CompetitionRoot';
import { Title } from '../Component/Title';
import { Info } from "../Component/Info"
import { ReturnTopPage } from '../Utility/ReturnTopPage';

/**
 * 作品登録完了画面
 */
export function KaguWorkComplete() {

    const [t] = useTranslation();

    const {lng} = useContext(i18nContext);

    const heldTimesOption = useContext(HeldTimesContext);

    return(
        <>
            <Box>
                <Title>
                    {t("KaguWorkComplete.Title", heldTimesOption)}
                </Title>
                <Info>
                    {t("KaguWorkComplete.Text1", heldTimesOption)}<br/>
                    {t("KaguWorkComplete.Text2")}
                </Info>
                <Grid2 container spacing={1} mt={1}>
                    <Grid2>
                        <Button variant="outlined" onClick={() => ReturnTopPage(lng)}>{t("Common.Back")}</Button>
                    </Grid2>
                </Grid2>
            </Box>
        </>
    );
}